export default __webpack_public_path__ + "static/media/comedor-mobile.5c2e365b.jpg";